var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "32px",
    viewBox: "0 0 31 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.0_Cadastro-do-usuario---menu-aberto",
    transform: "translate(-55.000000, -1170.000000)",
    fill: "#2B2B2B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(50.000000, 1166.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,4 C34.6568542,4 36,5.34314575 36,7 L36,33 C36,34.6568542 34.6568542,36 33,36 L19,36 C17.3431458,36 16,34.6568542 16,33 L16,27 L17.3,27 L17.3,32.7 C17.3,33.7543618 18.1158778,34.6181651 19.1507377,34.6945143 L19.3,34.7 L32.6,34.7 C33.6543618,34.7 34.5181651,33.8841222 34.5945143,32.8492623 L34.6,32.7 L34.6,7.3 C34.6,6.1954305 33.7045695,5.3 32.6,5.3 L19.3,5.3 C18.2456382,5.3 17.3818349,6.11587779 17.3054857,7.15073766 L17.3,7.3 L17.3,13 L16,13 L16,7 C16,5.34314575 17.3431458,4 19,4 L33,4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2614484,13.3885516 C12.5152892,13.6423924 12.5152892,14.0539496 12.2614484,14.3077904 L7.269,19.299171 L24.451829,19.3 C24.8108141,19.3 25.101829,19.5910149 25.101829,19.95 C25.101829,20.3089851 24.8108141,20.6 24.451829,20.6 L7.169,20.599171 L12.2614484,25.6922096 C12.5152892,25.9460504 12.5152892,26.3576076 12.2614484,26.6114484 C12.0076076,26.8652892 11.5960504,26.8652892 11.3422096,26.6114484 L5.19038059,20.4596194 C4.9365398,20.2057786 4.9365398,19.7942214 5.19038059,19.5403806 L11.3422096,13.3885516 C11.5960504,13.1347108 12.0076076,13.1347108 12.2614484,13.3885516 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.066416bb1f9b05dda43cac9a969087be.svg";
export { ForwardRef as ReactComponent };